module.exports = __webpack_public_path__ + "img/bg_main_market.12ca54c.png";